import $ from "../../../components/jquery";
import UIkit from "uikit";
import Toast from "../../../components/toast";
import { abrirExcecao } from "./excecao";
import "./historico.less";

const MODAL_ID = "cliente-reajuste-igpm-historico-modal";
const CONTAINER_ID = "cliente-reajuste-igpm-historico-container";
const REGISTRO = "[data-cliente-reajuste-igpm-registro]";
let geracao = 0;
let requisicaoAno: JQuery.jqXHR;
const requisicoesItens = new Map<number, JQuery.jqXHR>();

export interface ClienteReajusteIgpmHistoricoOptions {
    url: string;
    containerId?: string;
    competencia?: string;
    mesCompetencia?: number;
    anoCompetencia?: number;
    codReajusteSelecionado?: number;
    exibirLoading?: boolean;
}

export function abrirHistoricoReajuste(options: ClienteReajusteIgpmHistoricoOptions) {
    if (!options?.url) {
        Toast.error("URL do histórico de reajustes não configurada.");
        return;
    }
    carregarHistorico(options);
}

function cancelarRequisicoes() {
    geracao++;
    requisicaoAno?.abort();
    requisicaoAno = undefined;
    requisicoesItens.forEach(requisicao => requisicao.abort());
    requisicoesItens.clear();
}

function carregarHistorico(options: ClienteReajusteIgpmHistoricoOptions) {
    cancelarRequisicoes();
    const versao = geracao;
    let modal = $(`#${MODAL_ID}`);
    if (!modal.length || !modal.hasClass("uk-open")) {
        renderizarHistorico(criarModalInicial(), options);
        modal = $(`#${MODAL_ID}`);
    }
    const elemento = modal.get(0);
    modal.find("[data-igpm-historico-conteudo]").prop("hidden", true).attr("aria-busy", "true");
    modal.find("[data-igpm-historico-estado]").prop("hidden", false).empty()
        .append($("<span>", { text: "Carregando reajustes do ano…", role: "status" }));
    const requisicao = $.ajax({ url: options.url, data: montarFiltroHistorico(options), type: "GET", global: false });
    requisicaoAno = requisicao;
    requisicao.done((html) => {
        if (versao !== geracao || $(`#${MODAL_ID}`).get(0) !== elemento) return;
        if (!renderizarHistorico(html, options)) mostrarErroAno(modal, options);
    }).fail((_, status) => {
        if (versao === geracao && status !== "abort") mostrarErroAno(modal, options);
    }).always(() => {
        if (requisicaoAno === requisicao) requisicaoAno = undefined;
    });
}

function mostrarErroAno(modal: JQuery, options: ClienteReajusteIgpmHistoricoOptions) {
    modal.find("[data-igpm-historico-conteudo]").attr("aria-busy", "false");
    modal.find("[data-igpm-historico-estado]").prop("hidden", false).empty()
        .append($("<div>", { text: "Não foi possível carregar os reajustes deste ano.", role: "alert" }))
        .append($("<button>", { type: "button", class: "uk-button uk-button-default uk-button-small uk-margin-small-top", text: "Tentar novamente" })
            .on("click", () => carregarHistorico(options)));
}

function renderizarHistorico(html: string, options: ClienteReajusteIgpmHistoricoOptions) {
    const novoModal = $("<div>").append($.parseHTML(html, document, true) || []).find(`#${MODAL_ID}`);
    if (!novoModal.length) return false;
    const modalAtual = $(`#${MODAL_ID}`);
    if (modalAtual.length && modalAtual.hasClass("uk-open")) {
        modalAtual.find(".uk-modal-body").html(novoModal.find(".uk-modal-body").html() || "");
        ["data-itens-url", "data-excecao-url", "data-aplicar-excecao-url", "data-ano-competencia"].forEach(nome =>
            modalAtual.attr(nome, novoModal.attr(nome) || ""));
        inicializarHistorico(modalAtual, options);
        UIkit.update(modalAtual.get(0));
        abrirRegistroSelecionado(modalAtual, options.codReajusteSelecionado);
        return true;
    }
    modalAtual.remove();
    const container = obterContainer(options.containerId);
    container.empty().append(novoModal);
    const modal = container.find(`#${MODAL_ID}`);
    modal.on("hide.clienteReajusteIgpmHistoricoModal", function (event) {
        if (event.target !== this) return;
        cancelarRequisicoes();
    });
    modal.on("hidden.clienteReajusteIgpmHistoricoModal", function (event) {
        if (event.target !== this) return;
        modal.remove();
    });
    inicializarHistorico(modal, options);
    UIkit.modal(modal.get(0), { stack: true }).show();
    UIkit.update(modal.get(0));
    abrirRegistroSelecionado(modal, options.codReajusteSelecionado);
    return true;
}

function inicializarHistorico(modal: JQuery, options: ClienteReajusteIgpmHistoricoOptions) {
    modal.off(".clienteReajusteIgpmHistorico")
        .on("change.clienteReajusteIgpmHistorico", "[data-cliente-reajuste-igpm-historico-ano]", function () {
            carregarHistorico({ url: options.url, containerId: options.containerId, anoCompetencia: Number($(this).val()) });
        })
        .on("shown.clienteReajusteIgpmHistorico", REGISTRO, function (event) {
            if (event.target === this) carregarItens(modal, $(this), 1);
        })
        .on("hidden.clienteReajusteIgpmHistorico", REGISTRO, function (event) {
            if (event.target !== this) return;
            const codigo = Number($(this).attr("data-cliente-reajuste-igpm-registro"));
            const requisicao = requisicoesItens.get(codigo);
            requisicoesItens.delete(codigo);
            requisicao?.abort();
        })
        .on("click.clienteReajusteIgpmHistorico", "[data-igpm-itens-pagina]", function () {
            carregarItens(modal, $(this).closest(REGISTRO), Number($(this).attr("data-igpm-itens-pagina")), true);
        })
        .on("click.clienteReajusteIgpmHistorico", "[data-igpm-excecao]", function () {
            const item = Number($(this).attr("data-igpm-excecao"));
            const url = String(modal.attr("data-excecao-url") || "");
            const aplicarUrl = String(modal.attr("data-aplicar-excecao-url") || "");
            if (item > 0 && url && aplicarUrl) {
                abrirExcecao(item, url, aplicarUrl, (resultado) => carregarHistorico({
                    url: options.url, containerId: options.containerId,
                    anoCompetencia: resultado.anoCompetencia ?? resultado.AnoCompetencia,
                    codReajusteSelecionado: resultado.codReajuste ?? resultado.CodReajuste,
                    exibirLoading: false
                }));
            }
        });
}

function carregarItens(modal: JQuery, registro: JQuery, pagina: number, forcar = false) {
    const codigo = Number(registro.attr("data-cliente-reajuste-igpm-registro"));
    const ano = Number(modal.attr("data-ano-competencia"));
    const url = modal.attr("data-itens-url");
    const bloco = registro.find("[data-igpm-itens]");
    if (!codigo || !ano || !url || !bloco.length || !Number.isInteger(pagina) || pagina < 1) return;
    if (!forcar && (bloco.attr("data-carregado") === "true" || requisicoesItens.has(codigo))) return;
    requisicoesItens.get(codigo)?.abort();
    const versao = geracao;
    const elemento = modal.get(0);
    bloco.attr("aria-busy", "true").attr("data-carregado", "false").empty()
        .append($("<div>", { text: "Carregando subclientes…", role: "status" }));
    const requisicao = $.ajax({ url, data: { codReajuste: codigo, anoCompetencia: ano, pagina }, type: "GET", global: false });
    requisicoesItens.set(codigo, requisicao);
    const vigente = () => versao === geracao && requisicoesItens.get(codigo) === requisicao && $(`#${MODAL_ID}`).get(0) === elemento;
    requisicao.done((html) => {
        if (!vigente()) return;
        bloco.html(html).attr("data-carregado", "true");
        UIkit.update(registro.get(0));
    }).fail((_, status) => {
        if (!vigente() || status === "abort") return;
        bloco.attr("data-carregado", "false").empty()
            .append($("<div>", { text: "Não foi possível carregar os subclientes deste reajuste.", role: "alert" }))
            .append($("<button>", { type: "button", class: "uk-button uk-button-default uk-button-small uk-margin-small-top", text: "Tentar novamente", "data-igpm-itens-pagina": pagina }));
    }).always(() => {
        if (!vigente()) return;
        bloco.attr("aria-busy", "false");
        requisicoesItens.delete(codigo);
    });
}

function montarFiltroHistorico(options: ClienteReajusteIgpmHistoricoOptions) {
    const filtro: Record<string, number> = {};
    // Links antigos de avisos usam AAAA-MM. O mês não limita mais a consulta.
    const ano = Number(options.anoCompetencia || options.competencia?.split("-")[0] || 0);
    if (Number.isInteger(ano) && ano > 0) filtro.anoCompetencia = ano;
    const codigo = Number(options.codReajusteSelecionado || 0);
    if (Number.isInteger(codigo) && codigo > 0) filtro.codReajusteSelecionado = codigo;
    return filtro;
}

function obterContainer(containerId?: string) {
    const id = containerId || CONTAINER_ID;
    let container = $(`#${id}`);
    if (!container.length) {
        container = $(`<div id="${id}"></div>`);
        $("body").append(container);
    }
    return container;
}

function abrirRegistroSelecionado(modal: JQuery, codReajusteSelecionado?: number) {
    const codigo = Number(codReajusteSelecionado || 0);
    if (!Number.isInteger(codigo) || codigo <= 0) return;
    const registro = modal.find(`[data-cliente-reajuste-igpm-registro="${codigo}"]`);
    const elemento = registro.get(0);
    if (!elemento) return;
    registro.addClass("uk-open");
    carregarItens(modal, registro, 1);
    window.setTimeout(() => {
        if ($(`#${MODAL_ID}`).get(0) === modal.get(0) && elemento.isConnected) {
            elemento.scrollIntoView({ block: "center", behavior: "smooth" });
        }
    }, 150);
}

function criarModalInicial() {
    return `<div id="${MODAL_ID}" uk-modal="stack:true;">
        <div class="uk-modal-dialog uk-modal-dialog-large uk-margin-auto-vertical cliente-reajuste-igpm-historico-modal">
            <button class="uk-modal-close-default" type="button" uk-close></button>
            <div class="uk-modal-header"><h2 class="uk-modal-title">Histórico de reajustes por índice</h2>
                <div class="uk-text-meta">O reajuste anual dos clientes é aplicado automaticamente por IGP-M. Exceções individuais estão disponíveis no último reajuste vigente de cada subcliente.</div></div>
            <div class="uk-modal-body"><div data-igpm-historico-estado role="status"></div><div data-igpm-historico-conteudo hidden></div></div>
            <div class="uk-modal-footer uk-text-right"><button class="uk-button uk-button-default uk-button-small uk-modal-close" type="button">Fechar</button></div>
        </div></div>`;
}
